const identifyLessonCategory = (location) => {
  const segments = location.pathname.split("/");
  const knowledgeIndex = segments.indexOf("knowledge");
  const category = segments[knowledgeIndex + 1];

  return category;
};

export default identifyLessonCategory;
